<template>
  <div class="total-wrap">
    <div class="progress-wrap" v-if="$Util.isEmpty(electData.progressType)">
    </div>
    <div class="progress-wrap" v-else>
      <h3>현재 진행 현황은 <span class="accent head">"{{ progressList[electData.progressStatus].label }}"</span> 단계 입니다.</h3>
      <ul class="progress-info">
        <li v-for="(item, index) in progressList" :key="index"
            :class="{
              finished: Number(index) < electData.progressStatus,
              current: Number(index) === electData.progressStatus,
              after: Number(index) > electData.progressStatus,
              reverse: Math.floor((index - 1) / 4 % 2) === 1
            }"
        >
          <div class="status" :class="{reverse: Math.floor((index - 1) / 4 % 2) === 1}">
            <div class="status__marker"></div>
          </div>
          <div class="route" :class="{accent: Number(index) === electData.progressStatus}">{{ item.label }}</div>
        </li>
      </ul>
    </div>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
export default {
  props: {
    electData: {},
  },
  data: function () {
    return {
      progressList: []
    }
  },
  created: function () {
    this.progressList = this.$ConstCode.CODE_SERVICE_PROGRESS_STATUS[this.electData.progressType]
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.accent {
  color: #1980C3;

  &.head {
    font-size: 1.6rem;
  }
}

.progress-wrap {
  h3 {
    text-align: center;
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  .progress-info {
    position: relative;
    width: 70%;
    margin: 0 auto;

    li {
      position: relative;
      display: inline-block;
      width: 25%;
      border-top: 1px #BDBDBD solid;
      border-bottom: 1px white solid;
      vertical-align: top;
      text-align: center;

      &.finished {
        border-top: #28a745 solid 1px;

        &:nth-child(4) {
          border-right: #28a745 solid 1px;
        }

        &:nth-child(8) {
          border-left: #28a745 solid 1px;
        }

        &:nth-child(12) {
          border-right: 1px #28a745 solid;
        }

        &:nth-child(16) {
          border-left: 1px #28a745 solid;
        }

        .status {
          .status__marker {
            width: 1rem;
            height: 1rem;
            margin: -0.5rem auto 0;
            border: 3px #28a745 solid;
            border-radius: 0.5rem;
            background-color: white;
          }
        }

        .route {
          padding-top: 1rem;
          height: 6rem;
          color: #28a745;
        }
      }

      &.current {
        border-top: #28a745 solid 1px;

        &:after {
          padding: 0;
          display: block;
          content: "";
          width: calc(50% - 0.5rem);
          margin: 0 0 0 calc(50% + 0.5rem);
          height: 1px;
          background-color: #BDBDBD;
          position: absolute;
          left: 0;
          top: -1px;
        }

        &.reverse:after {
          padding: 0;
          margin: 0;
          display: block; /* probably not really needed? */
          content: "";
          width: calc(50% - 0.5rem);
          height: 1px;
          background-color: #BDBDBD;
          position: absolute;
          left: 0;
          top: -1px;
        }

        .status {
          .status__marker {
            width: 1rem;
            height: 1rem;
            margin: -0.5rem auto 0;
            border: 3px #1980C3 solid;
            border-radius: 0.5rem;
            background-color: white;
          }
        }

        .route {
          padding-top: 1rem;
          height: 6rem;
          color: #1980C3;
          font-weight: bold;
          font-size: 1.2rem;
        }
      }

      &.after {
        color: #BDBDBD;
      }

      &:first-child .status:before {
        content: "";
        display: block;
        width: 50%;
        border-top: 1px white solid;
        margin-top: -1px;
      }

      &:last-child .status:before {
        content: "";
        display: block;
        width: 50%;
        margin-left: 50%;
        border-top: 1px white solid;
        margin-top: -1px;
      }

      &:last-child .status.reverse:before {
        content: "";
        display: block;
        width: 50%;
        margin-left: 0;
        border-top: 1px white solid;
        margin-top: -1px;
      }

      &:nth-child(4) {
        border-right: 1px #BDBDBD solid;
      }

      &:nth-child(n + 5) {
        float: right;
      }

      &:nth-child(8) {
        border-left: 1px #BDBDBD solid;
      }

      &:nth-child(n + 9) {
        float: none;
      }

      &:nth-child(12) {
        border-right: 1px #BDBDBD solid;
      }

      &:nth-child(n + 13) {
        float: right;
      }

      &:nth-child(16) {
        border-left: 1px #BDBDBD solid;
      }

      &:nth-child(n + 17) {
        float: none;
      }

      .status {
        .status__marker {
          width: 1rem;
          height: 1rem;
          margin: -0.5rem auto 0;
          border: 3px #BDBDBD solid;
          border-radius: 0.5rem;
          background-color: white;
        }
      }

      .route {
        padding-top: 1rem;
        height: 6rem;
      }
    }
  }
}
</style>

